import React, { Component } from "react";
// import React, { Component , useState } from 'react';
import StepZilla from "react-stepzilla";
// import axios from 'axios';
import Box from "@material-ui/core/Box";
//import Link from '@material-ui/core/Link';
import { Switch, Route, Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
// import Link from "@material-ui/core/Link";
// import { Link as RouterLink } from "react-router-dom";

import kumon_logo from "./kumon_logo.png";

import Typography from "@material-ui/core/Typography";

import StepLanding from "./pages/stepLanding";
import StepStudentInfo from "./pages/stepStudentInfo";
import StepTnC from "./pages/stepTnC";
import StepEFT from "./pages/stepEFT";
import StepReview from "./pages/stepReview";

import StepSummary from "./pages/stepSummary";

import Terms from "./pages/TermsPrivacy";
import miscUtils from "./utils/misc";

import "./css/main.css";
const footerLinks = [
  {
    text: "Home",
    href: "",
  },
  {
    text: "Terms of Service",
    href: "terms",
  },
  {
    text: "Privacy",
    href: "privacy",
  },
];

class main extends Component {
  constructor(props) {
    super(props);

    this.sampleStore = {
      center: {
        id: "",
        name: "",
        terms: [],
        banners: [],
      },
      user: {
        token: "",
        email: "",
        pin: "",
        students: [],
        parentName: "",
        bankName: "",
        bankAccount: "",
        bankAccountType: "checking",
        bankRouting: "",
        confirmBankAccount: "",
        confirmBankRouting: "",

        accountHolderName: "",
        addressAddress: "",
        addressCity: "",
        addressState: "",
        addressZip: "",
        accountHolderPhone: "",
        signature: "",
        startDate: new Date(),
        reviewTitle: "",
      },

      savedToCloud: false,
    };

    /*
    this.sampleStore.user.parentName = 'dummy parent';
    // for debugging only.   
    let s1 = { name: 'Remove Student - 1', subjects: 'R'};
    let s2 = { name: 'Remove Student - 2', subjects: 'M,R'};
    this.sampleStore.user.students.push(s1);
    this.sampleStore.user.students.push(s2);
    */

    this.state = {
      center: { name: this.sampleStore.center.name },
      stepsNavigation: true,
    };
  }

  getCenterName(id) {
    return miscUtils.miscHelper.getCenterNameById(id);
  }

  getUrlPath(url) {
    if(url && url.pathname && url.pathname.length > 1)
      return url.pathname.slice(1);
    return '';
  }

  componentDidMount() {    
    const url = new URL(window.location.href);        
    let sd = window.SERVER_DATA; // server populates this.
    sd =
      typeof sd === "string"
        ? (sd = url.hostname === 'localhost' ? { id: this.getUrlPath(url), name: "TESTING" } : {})
        : sd;
    if(sd.id === '' || sd.id === undefined) { 
      window.location.href  = 'https://www.centersignup.com';
      return;
    }
    else {
      footerLinks.forEach(c => c.href = `/${sd.id}/${c.href}`);
      let center = { center: sd };
      this.setState((state, props) => {
        return { center: center };
      });
      const newState = Object.assign({}, this.state, center);
      this.setState(newState);
      this.updateStore({
        ...center,
      });
    }
  }

  getStore() {
    return this.sampleStore;
  }

  updateStore(update) {
    this.sampleStore = {
      ...this.sampleStore,
      ...update,
    };
  }

  render() {
    const steps = [
      {
        name: "Begin",
        component: (
          <StepLanding           
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },
    

      {
        name: "Student",
        component: (
          <StepStudentInfo
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },      
      {
        name: "Terms",
        component: (
          <StepTnC
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },
      {
        name: "Review",
        component: (
          <StepReview
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },
      

      {
        name: "Payment",
        component: (
          <StepEFT
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },
  
      {
        name: "Summary",
        component: (
          <StepSummary
            getStore={() => this.getStore()}
            updateStore={(u) => {
              this.updateStore(u);
            }}
          />
        ),
      },
    ];
    //const { updateActiveStep } = this.props;

    let stepzillaProps = {
      onStepChange: (step) =>
        this.setState({ stepsNavigation: step === (steps.count-1) ? false : true }),
      steps,
      preventEnterSubmission: false,
      nextTextOnFinalActionStep: "Submit",
      prevBtnOnLastStep: false,
    };
    const cId = this.state.center.id;
    return (
      <div>
        <Header cId={cId} name={this.state.center.name} />
        <nav className="topHeader">&nbsp;</nav>

        <Switch>
          <Route path={`/${cId}/terms`}>
            <Terms cId={this.state.center.id} mode="terms"></Terms>
          </Route>
          <Route path={`/${cId}/privacy`}>
            <Terms cId={this.state.center.id} mode="privacy"></Terms>
          </Route>
          <Route path="/">
            <Box mt={2}>
            <Typography                
                  variant='h5'>
                  Center Enrollment
                  </Typography>              
            </Box>
            <div className="step-progress">
              <StepZilla
                startAtStep={0}
                {...stepzillaProps}
                stepsNavigation={this.state.stepsNavigation}
              />
            </div>
          </Route>
        </Switch>

        <br />
        <Box mt={8}>
          <Footer name={this.state.center.name} />
        </Box>
        <br />
      </div>
    );
  }
}

function Header(props) {
  return (
    <div>
      <div className="mt-4">
        <Box className="headerLink" mt={4} mb={4}>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <img src={kumon_logo} alt="Kumon Logo" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Link to={`/${props.cId}`}>
                <Typography                
                  color="textSecondary" variant='subtitle1'
                  align="center"
                >
                  {"KUMON MATH AND READING CENTER OF"}
                </Typography>
                <Typography align="center" variant='h6'>
                  {props.name}
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
}

const styles = () => ({
  footerLine: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    height: "20vh",
  }
});

function Footer(props) {
  const classes = styles;
  //footerLinks[0].href = '';
  return (
    <div>
      <div className={classes.footerLine}>
        {footerLinks.map((fl, index) => (
          <Box component="span" ml={2} mr={2} key={index}>
            <Link to={fl.href}>{fl.text}</Link>
          </Box>
        ))}
      </div>
      <Box mt={1}>
        <Typography variant="body2" color="textSecondary" align="center">
          {"© "}
        {new Date().getFullYear()}&nbsp;{'All rights reserverd. Powered by CenterSignup.com'}
          {"."}          
          </Typography>
        <Typography variant="caption" color="textSecondary" align="center">
          {'Kumon is copyrighted to Kumon North America, Inc.'}
        </Typography>
      </Box>
    </div>
  );
}

export default main;


/*
Origin Request: Triggered before CloudFront redirects request to origin.
Origin Response: Triggered after CloudFront receives a response from origin
Viewer Request: Triggered when CloudFront receives a request from viewer
Viewer Response: Triggered before CloudFront returns response to viewer
*/